export const dvh = (value) => {
    const supportDvh = CSS.supports('height', '100dvh');
    return `${value}${supportDvh ? 'dvh' : 'vh'}`;
};
//# sourceMappingURL=styles.js.map